if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.thumbnails = this.querySelectorAll('.thumbnail-item');
        this.mediaItems = this.querySelectorAll('.media-wrapper');
        this.mainContainer = this.querySelector('.main-media-container');
        this.thumbnailWrapper = this.querySelector('.thumbnail-list-wrapper');
        this.prevButton = this.querySelector('.thumbnail-nav--prev');
        this.nextButton = this.querySelector('.thumbnail-nav--next');
        this.scrollStep = 106; // 90px thumbnail height + 16px gap
        
        this.init();
      }

      init() {
        if (!this.thumbnails || !this.mediaItems || !this.mainContainer) return;
        
        this.thumbnails.forEach(thumbnail => {
          thumbnail.addEventListener('click', this.handleThumbnailClick.bind(this));
        });

        if (this.prevButton && this.nextButton) {
          this.prevButton.addEventListener('click', () => this.scrollThumbnails('prev'));
          this.nextButton.addEventListener('click', () => this.scrollThumbnails('next'));
        }
        
        // Set initial scroll position and button visibility
        this.updateScrollButtons();
      }

      handleThumbnailClick(event) {
        event.preventDefault();
        const thumbnail = event.currentTarget;
        const mediaId = thumbnail.dataset.mediaId;
        if (!mediaId) return;
        
        this.setActiveMedia(mediaId);
      }

      setActiveMedia(mediaId) {
        if (!mediaId) return;
        
        // Update thumbnails
        this.thumbnails.forEach(thumbnail => {
          thumbnail.classList.toggle('active', thumbnail.dataset.mediaId === mediaId);
          thumbnail.setAttribute('aria-current', thumbnail.dataset.mediaId === mediaId);
        });

        // Update media display
        this.mediaItems.forEach(item => {
          const isActive = item.dataset.mediaId === mediaId;
          if (isActive) {
            item.classList.add('active');
            item.removeAttribute('hidden');
          } else {
            item.classList.remove('active');
            item.setAttribute('hidden', '');
          }

          // Handle video/3D model loading
          if (isActive) {
            if (item.querySelector('video')) {
              item.querySelector('video').play();
            }
            if (item.querySelector('model-viewer')) {
              item.querySelector('model-viewer').play();
            }
          }
        });
      }

      scrollThumbnails(direction) {
        if (!this.thumbnailWrapper) return;
        
        const isMobile = window.innerWidth < 749;
        const currentScroll = this.thumbnailWrapper.scrollTop;
        const currentScrollLeft = this.thumbnailWrapper.scrollLeft;
        
        if (isMobile) {
          const newScroll = direction === 'prev'
            ? currentScrollLeft - this.scrollStep
            : currentScrollLeft + this.scrollStep;
          
          this.thumbnailWrapper.scrollTo({
            left: newScroll,
            behavior: 'smooth'
          });
        } else {
          const newScroll = direction === 'prev'
            ? currentScroll - this.scrollStep
            : currentScroll + this.scrollStep;
          
          this.thumbnailWrapper.scrollTo({
            top: newScroll,
            behavior: 'smooth'
          });
        }
        
        setTimeout(() => this.updateScrollButtons(), 300);
      }

      updateScrollButtons() {
        if (!this.thumbnailWrapper || !this.prevButton || !this.nextButton) return;
        
        const isMobile = window.innerWidth < 749;
        
        if (isMobile) {
          const scrollLeft = this.thumbnailWrapper.scrollLeft;
          const scrollWidth = this.thumbnailWrapper.scrollWidth;
          const clientWidth = this.thumbnailWrapper.clientWidth;
          
          this.prevButton.classList.toggle('hidden', scrollLeft <= 0);
          this.nextButton.classList.toggle('hidden', scrollLeft + clientWidth >= scrollWidth);
        } else {
          const scrollTop = this.thumbnailWrapper.scrollTop;
          const scrollHeight = this.thumbnailWrapper.scrollHeight;
          const clientHeight = this.thumbnailWrapper.clientHeight;
          
          this.prevButton.classList.toggle('hidden', scrollTop <= 0);
          this.nextButton.classList.toggle('hidden', scrollTop + clientHeight >= scrollHeight);
        }
      }
    }
  );
}
